import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-antiragg',
    templateUrl: './antiragg.component.html',
    styleUrls: ['./antiragg.component.scss']
})
export class AntiraggComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s ANTI-RAGGING: Promoting a Safe Campus Environment');
        this.meta.updateTag({
            name: 'description',
            content: `Learn about ARNI’s ANTI RAGGING initiatives, ensuring a safe, respectful, and inclusive environment for all students, free from harassment and bullying.`
        });
    }

}
